import React from 'react';
import { Container, Row, View } from '@amzn/stencil-react-components/layout';
import { Label } from '@amzn/stencil-react-components/text';
import FaqFlyout from './FaqFlyout';
import LanguageSelectFlyout from './LanguageSelectFlyout';
import { recordEvent } from 'src/analytics/amplify'

export default function Footer() {

    function handleFaqFlyoutClick() {
        recordEvent({
            name: 'Footer.FaqFlyout.Click',
            immediate: true
        });
    }

    return (
        <Container>
            <hr />
            <Row gridGap="S500" alignItems="center" justifyContent="center" >
                <LanguageSelectFlyout />
                <View alignItems="center">
                    <Label textAlign="center">
                        .
                    </Label>
                </View>
                <div onClick={() => handleFaqFlyoutClick()}>
                    <FaqFlyout />
                </div>
            </Row>
        </Container>
    );
}
